import type { HarborOperatorDashboardTrendPoint } from '@/types/harbor-operator-dashboard.types';

type TrendRow = HarborOperatorDashboardTrendPoint & {
  netRevenue?: number | string;
  net_revenue?: number | string;
  revenue?: number | string;
  amount?: number | string;
};

/** Coerce API trend rows (string numbers, camelCase, alternate amount fields). */
export function normalizeTrendPoints(
  points: HarborOperatorDashboardTrendPoint[] | undefined
): HarborOperatorDashboardTrendPoint[] {
  return (points ?? []).map((point) => {
    const row = point as TrendRow;
    const netRevenue = Number(
      row.net_revenue ?? row.netRevenue ?? row.revenue ?? row.amount ?? 0
    );
    return {
      period: String(row.period ?? ''),
      bookings: Number(row.bookings ?? 0),
      net_revenue: Number.isFinite(netRevenue) ? netRevenue : 0,
    };
  });
}

/** Prefer revenue_trend; fall back to bookings_trend when revenue series is empty. */
export function pickRevenueTrendSeries(
  revenueTrend: HarborOperatorDashboardTrendPoint[] | undefined,
  bookingsTrend: HarborOperatorDashboardTrendPoint[] | undefined
): HarborOperatorDashboardTrendPoint[] {
  const revenue = normalizeTrendPoints(revenueTrend);
  if (revenue.length > 0) {
    return revenue;
  }
  return normalizeTrendPoints(bookingsTrend);
}
